/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Rest_PlusInputs */

const en_us2_workout_rest_plus = /** @type {(inputs: Workout_Rest_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+15 s`)
};

const pt_br2_workout_rest_plus = /** @type {(inputs: Workout_Rest_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+15 s`)
};

const es_419_workout_rest_plus = /** @type {(inputs: Workout_Rest_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+15 s`)
};

const pt_pt2_workout_rest_plus = /** @type {(inputs: Workout_Rest_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+15 s`)
};

const fr_fr2_workout_rest_plus = /** @type {(inputs: Workout_Rest_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+15 s`)
};

const de_de2_workout_rest_plus = /** @type {(inputs: Workout_Rest_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+15 s`)
};

const it_it2_workout_rest_plus = /** @type {(inputs: Workout_Rest_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+15 s`)
};

/**
* | output |
* | --- |
* | "+15 s" |
*
* @param {Workout_Rest_PlusInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_rest_plus = /** @type {((inputs?: Workout_Rest_PlusInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Rest_PlusInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_rest_plus(inputs)
	if (locale === "es-419") return es_419_workout_rest_plus(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_rest_plus(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_rest_plus(inputs)
	if (locale === "de-DE") return de_de2_workout_rest_plus(inputs)
	if (locale === "it-IT") return it_it2_workout_rest_plus(inputs)
	return en_us2_workout_rest_plus(inputs)
});
export { workout_rest_plus as "workout.rest_plus" }